import { useTheme } from 'styled-components'
import { IconButton } from '../IconButton/IconButton'
import { ArrowIcon, Container } from './NavigationButton.styles'
import type { NavigationButtonProps } from './NavigationButton.types'

export const NavigationButton = ({
  onClick,
  buttonType,
}: NavigationButtonProps): JSX.Element => {
  const iconColor = useTheme().colors.text.primary

  return (
    <Container buttonType={buttonType} onClick={onClick}>
      <IconButton color={iconColor} buttonType={buttonType} iconSize="1.3rem">
        <ArrowIcon />
      </IconButton>
    </Container>
  )
}
